import { ITemplateConfig } from "../../../../constants/interfaces";

export const templates: ITemplateConfig[] = [
	{
		id: 1,
		message: 'Currenly no UserData available from Google Analytics',
		description: "",
		brands: [],
		grid_type_id: 1,
		grid_type: 'list, chart, two metrics',
		grid_config: [
			{
				cell_id: 1,
				allowed_content_type: [
					'list',
					'video_list',
					'notification_centre',
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 1',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 2,
				allowed_content_type: [
					'list',
					'video_list',
					'notification_centre',
					'chart',
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 2',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 3,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 3',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 4,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 4',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			}
		]
	},
	{
		id: 2,
		message: 'Currenly no UserData available from Google Analytics',
		description: "",
		brands: [],
		grid_type_id: 2,
		grid_type: 'list, chart, two metrics',
		grid_config: [
			{
				cell_id: 1,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 1',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 2,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 2',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 3,
				allowed_content_type: [
					'list',
					'video_list',
					'notification_centre',
					'chart',
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 3',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 4,
				allowed_content_type: [
					'list',
					'video_list',
					'notification_centre',
					'chart',
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 4',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			}
		]
	},
	{
		id: 3,
		message: 'Currenly no UserData available from Google Analytics',
		description: "",
		brands: [],
		grid_type_id: 3,
		grid_type: 'list, chart, two metrics',
		grid_config: [
			{
				cell_id: 1,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 1',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 2,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 2',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 3,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 3',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 4,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 4',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 5,
				allowed_content_type: [
					'list',
					'video_list',
					'notification_centre',
					'chart',
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 5',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			}
		]
	},
	{
		id: 4,
		message: 'Currenly no UserData available from Google Analytics',
		description: "",
		brands: [],
		grid_type_id: 4,
		grid_type: 'list, four metrics',
		grid_config: [
			{
				cell_id: 1,
				allowed_content_type: [
					'list',
					'video_list',
					'notification_centre',
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 1',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 2,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 2',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 3,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 3',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 4,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 4',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 5,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 5',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			}
		]
	},
	{
		id: 5,
		message: 'Currenly no UserData available from Google Analytics',
		description: "",
		brands: [],
		grid_type_id: 5,
		grid_type: 'list, four metrics',
		grid_config: [
			{
				cell_id: 1,
				allowed_content_type: [
					'list',
					'video_list',
					'notification_centre',
					'chart',
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 1',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 2,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 2',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 3,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 3',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 4,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 4',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 5,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 5',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 6,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 6',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 7,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 7',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			}
		]
	},
	{
		id: 6,
		message: 'Currenly no UserData available from Google Analytics',
		description: "",
		brands: [],
		grid_type_id: 6,
		grid_type: 'list, four metrics',
		grid_config: [
			{
				cell_id: 1,
				allowed_content_type: [
					'list',
					'video_list',
					'notification_centre',
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 1',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 2,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 2',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 3,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 3',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 4,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 4',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 5,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 5',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 6,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 6',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 7,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 7',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 8,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 8',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			}
		]
	},
	{
		id: 7,
		message: 'Currenly no UserData available from Google Analytics',
		description: "",
		brands: [],
		grid_type_id: 7,
		grid_type: 'list, four metrics',
		grid_config: [
			{
				cell_id: 1,
				allowed_content_type: [
					'list',
					'video_list',
					'notification_centre',
					'chart',
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 1',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 2,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 2',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 3,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 3',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 4,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 4',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 5,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 5',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 6,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 6',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 7,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 7',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 8,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 8',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 9,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 9',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 10,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 10',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 11,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 11',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 12,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 12',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 13,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 13',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			}
		]
	},
	{
		id: 8,
		message: 'Currenly no UserData available from Google Analytics',
		description: "",
		brands: [],
		grid_type_id: 8,
		grid_type: 'list, chart, center',
		grid_config: [
			{
				cell_id: 1,
				allowed_content_type: [
					'list',
					'video_list',
					'notification_centre',
					'chart',
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 1',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 2,
				allowed_content_type: [
					'list',
					'video_list',
					'notification_centre',
					'chart',
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 2',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 3,
				allowed_content_type: [
					'list',
					'video_list',
					'notification_centre',
					'chart',
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 3',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 4,
				allowed_content_type: [
					'list',
					'video_list',
					'notification_centre',
					'chart',
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 4',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			}
		]
	},
	{
		id: 9,
		message: 'Currenly no UserData available from Google Analytics',
		description: "",
		brands: [],
		grid_type_id: 9,
		grid_type: 'list, video list',
		grid_config: [
			{
				cell_id: 1,
				allowed_content_type: [
					'list',
					'video_list',
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 1',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			}
		]
	},
	{
		id: 10,
		message: 'Currenly no UserData available from Google Analytics',
		description: "",
		brands: [],
		grid_type_id: 10,
		grid_type: 'list, video list',
		grid_config: [
			{
				cell_id: 1,
				allowed_content_type: [
					'list',
					'video_list',
					'notification_centre',
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 1',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 2,
				allowed_content_type: [
					'list',
					'video_list',
					'notification_centre',
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 2',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			}
		]
	},
	{
		id: 11,
		message: 'Currenly no UserData available from Google Analytics',
		description: "",
		brands: [],
		grid_type_id: 11,
		grid_type: 'coral reef',
		grid_config: [
			{
				cell_id: 1,
				allowed_content_type: [
					'list',
					'video_list',
					'notification_centre',
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 1',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 2,
				allowed_content_type: [
					'list',
					'video_list',
					'notification_centre',
					'chart',
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 2',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 3,
				allowed_content_type: [
					'list',
					'video_list',
					'notification_centre',
					'chart',
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 3',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 4,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 4',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 5,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 5',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			}
		]
	},
	{
		id: 12,
		message: 'Currenly no UserData available from Google Analytics',
		description: "",
		brands: [],
		grid_type_id: 12,
		grid_type: 'coral reef',
		grid_config: [
			{
				cell_id: 1,
				allowed_content_type: [
					'list',
					'video_list',
					'notification_centre',
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 1',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 2,
				allowed_content_type: [
					'list',
					'video_list',
					'notification_centre',
					'chart',
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 2',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 3,
				allowed_content_type: [
					'list',
					'video_list',
					'notification_centre',
					'chart',
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 3',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 4,
				allowed_content_type: [
					'list',
					'video_list',
					'notification_centre',
					'chart',
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 4',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 5,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 5',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 6,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 6',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			}
		]
	},



	{
		id: 14,
		message: 'Currenly no UserData available from Google Analytics',
		description: "",
		brands: [],
		grid_type_id: 14,
		grid_type: '6 fileds',
		grid_config: [
			{
				cell_id: 1,
				allowed_content_type: [
					'list',
					'video_list',
					'notification_centre',
					'chart',
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 1',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 2,
				allowed_content_type: [
					'list',
					'video_list',
					'notification_centre',
					'chart',
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 2',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 3,
				allowed_content_type: [
					'list',
					'video_list',
					'notification_centre',
					'chart',
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 3',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 4,
				allowed_content_type: [
					'list',
					'video_list',
					'notification_centre',
					'chart',
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 4',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 5,
				allowed_content_type: [
					'list',
					'video_list',
					'notification_centre',
					'chart',
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 5',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 6,
				allowed_content_type: [
					'list',
					'video_list',
					'notification_centre',
					'chart',
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 6',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			}
		]
	},

	{
		id: 15,
		message: 'Currenly no UserData available from Google Analytics',
		description: "",
		brands: [],
		grid_type_id: 15,
		grid_type: '6 fileds',
		grid_config: [
			{
				cell_id: 1,
				allowed_content_type: [
					'list',
					'video_list',
					'notification_centre',
					'chart',
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 1',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 2,
				allowed_content_type: [
					'list',
					'video_list',
					'notification_centre',
					'chart',
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 2',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 3,
				allowed_content_type: [
					'list',
					'video_list',
					'notification_centre',
					'chart',
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 3',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 4,
				allowed_content_type: [
					'list',
					'video_list',
					'notification_centre',
					'chart',
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 4',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 5,
				allowed_content_type: [
					'list',
					'video_list',
					'notification_centre',
					'chart',
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 5',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 6,
				allowed_content_type: [
					'list',
					'video_list',
					'notification_centre',
					'chart',
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 6',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			}
		]
	},
	{
		id: 16,
		message: 'Currenly no UserData available from Google Analytics',
		description: "",
		brands: [],
		grid_type_id: 16,
		grid_type: '1 large 16 small fileds',
		grid_config: [
			{
				cell_id: 1,
				allowed_content_type: [
					'list',
					'video_list',
					'notification_centre',
					'chart',
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 1',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 2,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 2',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 3,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 3',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 4,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 4',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 5,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 5',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 6,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 6',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 7,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 7',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 8,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 8',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 9,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 9',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 10,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 10',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 11,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 11',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 12,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 12',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 13,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 13',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 14,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 14',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 15,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 15',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 16,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 16',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			{
				cell_id: 17,
				allowed_content_type: [
					'metric'
				],
				sections: [],
				event_fields: [],
				custom_fields: [],
				user_needs: [],
				brands: [],
				referrers: [],
				referrer_types: [],
				tags: [],
				conversions: [],
				posted_on_channels: [],
				paid_type: "",
				sort: '',
				video_filter: "",
				page_type: "",
				refresh: '60s',
				time_window: '30m',
				pubdate_interval: '',
				show_circles: 0,
				not_on_homepage: 0,
				weighted_result: 0,
				label: 'Component 17',
				notification_type: "",
				cell_content_type: "",
				content_type: "",
				graph_metric: "",
				fields: []
			},
			
		]
	},
]
export const goalTemplate = {
	id: 0,
	message: "Currenly no UserData available from Google Analytics",
	description: "Example goal",
	brands: [],
	grid_type_id: 0,
	grid_type: "list, video list",
	grid_config: [
		{
			cell_id: 1,
			allowed_content_type: ["metric"],
			sections: [],
			brands: [],
			refresh: "60s",
			time_window: "30m",
			show_circles: 0,
			not_on_homepage: 0,
			weighted_result: 0,
			label: "Component 1",
			notification_type: "",
			cell_content_type: "",
			content_type: "",
			graph_metric: "",
			fields: [],
		},
		{
			cell_id: 2,
			allowed_content_type: ["list"],
			sections: [],
			brands: [],
			refresh: "60s",
			time_window: "30m",
			show_circles: 0,
			not_on_homepage: 0,
			weighted_result: 0,
			label: "Component 2",
			notification_type: "",
			cell_content_type: "",
			content_type: "",
			graph_metric: "",
			fields: [],
		},
	],
};
